import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-simple-form-group-input',
    templateUrl: './simple-form-group-input.component.html',
    styleUrls: ['./simple-form-group-input.component.css'],
    standalone: false
})
export class SimpleFormGroupInputComponent implements OnInit {

  @Input()
  label: string;

  @Input()
  inputType: string;

  @Input()
  additionalClass: string;

  @Input()
  placeHolder: string;

  @Input()
  model: string;

  @Input()
  disabled = false;

  @Input()
  helpText = '';

  @Input()
  errorText = '';

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  change() {
    this.modelChange.emit(this.model);
  }

}
